import * as React from 'react';

import {FormattedTimestamp} from 'shells/timestamp/formatted-timestamp';

type Props = {
    archivedTime: any;
};

export function AudienceArchivedTime(props: Props) {
    const archivedTime = props.archivedTime;

    return (
        <div className='flex align-center light-text'>
            Archived on&nbsp;
            <FormattedTimestamp
                format={FormattedTimestamp.formats.longMonthDayWithYear}
                datetime={archivedTime}
            />
        </div>
    );
}
